/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useState } from 'react';

import {
	useEditDirectorySettingsMutation,
	useGetDirectoryCodeQuery,
	useGetDirectorySettingsQuery
} from 'store/api/version-api.slice';

import DirectorySettingsDialog from './DirectorySettingsDialog';
import { styles } from './styles';

const DirectorySettingsView = () => {
	const [formOpen, setFormOpen] = useState(false);
	const [directoryOptions, setDirectoryOptions] = useState([]);

	const { data: directorySettingsResponse = {} } = useGetDirectorySettingsQuery();
	const directorySettings = directorySettingsResponse.results || [];

	const { data: directoryCodeResponse = {} } = useGetDirectoryCodeQuery();

	const [editDirectorySettings, { isLoading: isEditLoading }] = useEditDirectorySettingsMutation();

	const toggleForm = () => setFormOpen(prev => !prev);

	const handleChange = dirOptions => {
		setDirectoryOptions(dirOptions);
	};

	const handleSave = async () => {
		if (directoryOptions.length > 0) {
			editDirectorySettings({ id: directoryOptions[0].account, payload: directoryOptions[0] });
		} else {
			editDirectorySettings({ id: directorySettings[0].account, payload: directorySettings[0] });
		}

		toggleForm();
	};

	return (
		<Box sx={styles.root}>
			<Box>
				<Paper elevation={2}>
					<Toolbar>
						<Typography component={'span'} variant="h6" color="primary" sx={styles.title}>
							MEMBERSHIP DIRECTORY
						</Typography>
					</Toolbar>
					<Divider />
					<Box sx={styles.content}>
						<Box key={`member-form-0`} display="flex" flexDirection="column">
							<Typography variant={'h6'} component={'span'}>
								Embeddable Code:
							</Typography>
							<Typography component={'span'} sx={styles.code_block}>
								{[directoryCodeResponse.script_code]}
							</Typography>
						</Box>
						<Box
							sx={{
								padding: '8px',
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between'
							}}
						>
							<Button
								color="primary"
								variant={'contained'}
								sx={{ marginBottom: '8px' }}
								onClick={toggleForm}
							>
								Directory Settings
							</Button>
						</Box>
					</Box>
				</Paper>
			</Box>
			<DirectorySettingsDialog
				formOpen={formOpen}
				handleChange={handleChange}
				handleSave={handleSave}
				isLoading={isEditLoading}
				toggleForm={toggleForm}
			/>
		</Box>
	);
};

export default DirectorySettingsView;
